// SPDX-License-Identifier: Apache-2.0
//
// 레이어 2 컴포넌트의 한국어 메시지. 키는 en.js와 같습니다.
// Korean messages of the layer 2 components; the same keys as en.js.

export default {
  common: {
    loading: '불러오는 중'
  },
  alert: {
    dismiss: '닫기'
  },
  breadcrumb: {
    label: '이동 경로'
  },
  carousel: {
    carousel: '캐러셀',
    slide: '슬라이드',
    position: '{total}개 중 {index}번째',
    goTo: '{index}번 슬라이드로 이동',
    prev: '이전 슬라이드',
    next: '다음 슬라이드',
    pause: '일시 정지',
    play: '재생'
  },
  chart: {
    label: '차트',
    legend: '범례',
    point: '{series}, {label}: {value}'
  },
  confirm: {
    ok: '확인',
    cancel: '취소'
  },
  datePicker: {
    placeholder: 'YYYY-MM-DD'
  },
  dateRangePicker: {
    start: '시작일',
    end: '종료일'
  },
  emptyState: {
    title: '데이터가 없습니다'
  },
  grid: {
    select: '선택',
    selectAll: '이 페이지의 모든 행 선택',
    selectRow: '{index}행 선택',
    range: '{total}개 중 {from}–{to}'
  },
  modal: {
    close: '닫기'
  },
  numberInput: {
    decrement: '감소',
    increment: '증가'
  },
  pagination: {
    label: '페이지 이동',
    previous: '이전 페이지',
    next: '다음 페이지',
    page: '{page} 페이지'
  },
  passwordInput: {
    show: '보기',
    hide: '숨기기'
  },
  rating: {
    label: '평점',
    value: '{max}점 중 {value}점'
  },
  searchInput: {
    label: '검색',
    placeholder: '검색',
    clear: '검색어 지우기'
  },
  sparkline: {
    summary: '{first}에서 {last}, 최저 {min}, 최고 {max}',
    empty: '데이터 없음'
  },
  splitButton: {
    more: '다른 동작'
  },
  statCard: {
    up: '증가',
    down: '감소'
  },
  stepper: {
    complete: '완료'
  },
  tag: {
    remove: '{label} 삭제'
  },
  timePicker: {
    placeholder: 'HH:MM'
  },
  toast: {
    dismiss: '닫기',
    region: '알림'
  }
};
